module.exports = __webpack_public_path__ + "media/images/budget-a8c3e2e2249f05ac781151ebb7b0f457.png";